import BaseModel from './BaseModel'
import ParentSpotRate from './ParentSpotRate'
import Venue from './Venue'
import buildQuerystring from '../utils/buildQuerystring'
import { Temporal } from '@js-temporal/polyfill'

/**
 * @todo Add types for API methods.
 */
export default class Event extends BaseModel {

  static entity = 'events'
  static primaryKey = 'ID'

  declare ID: number
  declare venueID: number
  declare venueName: string
  declare name: string
  declare eventStartLocal: string
  declare eventEndLocal: string
  declare channels: string[]
  declare parentSpotRates: ParentSpotRate[]
  declare venue: Venue

  static fields() {

    return {

      // fields
      ID: this.number(null),
      venueID: this.number(null),
      venueName: this.string(null),
      name: this.string(null),
      eventStartLocal: this.string(null),
      eventEndLocal: this.string(null),
      channels: this.attr(null), // array of strings

      // relationships
      parentSpotRates: this.hasMany(ParentSpotRate, 'eventID'),
      venue: this.belongsTo(Venue, 'venueID'),

    }

  }

  /**
   * API methods
   */


  /**
   * @deprecated Use getByLocationId() instead.
   */
  static fetchByLocationID(locationID: number, options = {}) {

    let url = `/venues/location/${locationID}/event`
    url += buildQuerystring(options, ['start', 'end'])

    return this.api().get(url, {
      save: false,
    })

  }

  static getByLocationId(locationId: number, options: GetByLocationIdOptions = {}): Promise<GetEventsByLocationResponseItem[]> {

    return this.api().get(`/venues/location/${locationId}/event`, {
      params: {
        start: options.start?.toString(),
        end: options.end?.toString(),
      },
      save: false,
      // @ts-ignore TypeScript claims that signal is not a valid Config property, which isn't true (I even tested it, and it's definitely working)
      signal: options.signal,
    }).then(response => {
      return response.response.data.events.map((event: any) => {
        event.eventStartLocal = Temporal.PlainDateTime.from(event.eventStartLocal)
        event.eventEndLocal = Temporal.PlainDateTime.from(event.eventEndLocal)
        return event
      })
    })

  }

}

export interface GetByLocationIdOptions {
  start?: Temporal.PlainDate
  end?: Temporal.PlainDate
  signal?: AbortSignal
}

export interface GetEventsByLocationResponseItem {
  ID: number
  venueID: number
  venueName: string
  name: string
  eventStartLocal: Temporal.PlainDateTime,
  eventEndLocal: Temporal.PlainDateTime,
  channels: string[]
}
